(function(){
  function isProductPage(){
    return !!document.querySelector('[id^="blocky-featured-product-"]');
  }

  function fixProductScroll(){
    if(!isProductPage()) return;

    var html = document.documentElement;
    var body = document.body;
    var main = document.getElementById('MainContent');

    html.style.setProperty('overflow-y','auto','important');
    html.style.setProperty('height','auto','important');
    body.style.setProperty('overflow-y','visible','important');
    body.style.setProperty('overflow-x','clip','important');
    body.style.setProperty('height','auto','important');

    if(main){
      main.style.setProperty('overflow','visible','important');
      main.style.setProperty('height','auto','important');
      main.style.setProperty('max-height','none','important');
    }

    document.querySelectorAll('section, .shopify-section, [class*="blocky-"]').forEach(function(el){
      var cs = window.getComputedStyle(el);
      if(cs.overflowY === 'auto' || cs.overflowY === 'scroll'){
        el.style.setProperty('overflow-y','visible','important');
        el.style.setProperty('max-height','none','important');
        el.style.setProperty('height','auto','important');
      }
    });
  }

  function run(){
    fixProductScroll();
    [100,300,700,1500,3000].forEach(function(ms){ setTimeout(fixProductScroll,ms); });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',run);
  }else{
    run();
  }
})();